const LOGO_SRC = "/assets/logo-redstone.png";

export function LogoMark({ className = "h-10" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Red Stone Beer and Grill — logo ufficiale"
      className={`${className} w-auto select-none`}
      draggable="false"
    />
  );
}

export function StoneMark({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path d="M24 3 43 18 24 45 5 18Z" fill="#530C19" />
      <path d="M24 3 33 18 24 45 15 18Z" fill="#82162B" />
      <path d="M24 3 43 18 33 18Z" fill="#A81E37" />
      <path d="M24 3 15 18 5 18Z" fill="#6B1020" />
      <path d="M15 18 24 45 5 18Z" fill="#460A15" />
      <path d="M33 18 24 45 43 18Z" fill="#8F1A30" />
      <path d="M5 18h38M15 18 24 3l9 15M15 18l9 27 9-27" fill="none" stroke="#DFBC7A" strokeWidth="1.1" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo() {
  return (
    <a href="/" className="flex items-center group" data-testid="brand-logo">
      <LogoMark className="h-12 sm:h-14 transition-transform duration-500 group-hover:scale-[1.04]" />
    </a>
  );
}
